import React from 'react';
import { X, Image as ImageIcon } from 'lucide-react';

/**
 * Dialog modale per visualizzare i dettagli di un esercizio
 */
const ExerciseInfoDialog = ({ exercise, onClose }) => {
  if (!exercise) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]" onClick={onClose}>
      <div 
        className="bg-white dark:bg-gray-800 rounded-lg p-5 max-w-2xl w-[95%] max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()} // Previene la chiusura quando si clicca sul contenuto
      >
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">
            {exercise.nome}
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
          >
            <X className="h-6 w-6 text-gray-500 dark:text-gray-400" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Immagine */}
          <div className="w-full">
            {exercise.immagine_statica ? (
              <div className="w-full h-64 bg-gray-100 dark:bg-gray-700 rounded-lg overflow-hidden">
                <img
                  src={exercise.immagine_statica}
                  alt={exercise.nome}
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.style.display = 'none';
                    if (e.target.parentNode) {
                      e.target.parentNode.innerHTML += `
                        <div class="flex items-center justify-center h-full">
                          <div class="text-center text-gray-500">
                            <svg class="w-12 h-12 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                          </svg>
                          <p class="text-sm">Immagine non disponibile</p>
                        </div>
                      </div>
                    `;
                    }
                  }}
                />
              </div>
            ) : (
              <div className="flex items-center justify-center w-full h-64 bg-gray-100 dark:bg-gray-700 rounded-lg">
                <div className="text-center text-gray-500 dark:text-gray-400">
                  <ImageIcon className="w-12 h-12 mx-auto mb-2" />
                  <p className="text-sm">Nessuna immagine disponibile</p>
                </div>
              </div>
            )}
          </div>

          {/* Dettagli */}
          <div className="space-y-4">
            <div>
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">
                Gruppo Muscolare
              </h4>
              <p className="text-gray-800 dark:text-gray-200">
                {exercise.gruppo_muscolare || "Non specificato"}
              </p>
            </div>

            {exercise.attrezzatura && (
              <div>
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">
                  Attrezzatura
                </h4>
                <p className="text-gray-800 dark:text-gray-200">
                  {exercise.attrezzatura}
                </p>
              </div>
            )}

            {exercise.descrizione && (
              <div>
                <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">
                  Descrizione
                </h4>
                <p className="text-gray-800 dark:text-gray-200 whitespace-pre-line">
                  {exercise.descrizione}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExerciseInfoDialog;